import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch } from "../../../../app/hooks";
import { apiActions } from "../../../../slices/api-slice";
import { ApiGetCloudFolderFileDownload } from "../../../../api/cf/cloud-folder/api-get-cloud-folder-file-download";
import { Image as ImageComponent, ImageProps } from "../../image/image";
import { useParams } from "react-router-dom";
import { PathParams } from "../../../../routes/routing-path";
import { CfFile } from "../folder-drop-zone.olc";
type LazyThumbProps = {
  orderId: string,
  cache: React.MutableRefObject<Record<string, string>>,
  cfFile: CfFile,
  imageProps?: Partial<ImageProps>,
};

export const LazyThumb = React.memo((props: LazyThumbProps) => {
  const dispatch = useAppDispatch();
  const {
    cache,
    orderId,
    cfFile,
    imageProps,
  } = props;
  // - Params -
  const { kijshopCd } = useParams<PathParams>();
  const ref = useRef<HTMLDivElement>(null);
  // - State -
  const [src, setSrc] = useState<string | undefined>(() => cache.current[cfFile.id] ?? cfFile.dataPath);
  // - Ref -
  const loaded = useRef(false);
  // - Effect -
  useEffect(() => {
    if (src) return;
    if (!ref.current) return;
    const cached = cache.current[cfFile.id];
    if (cached) {
      setSrc(cached);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || loaded.current) return;
        loaded.current = true;
        if (!cfFile.pathThumb) return;
        dispatch(apiActions.run(new ApiGetCloudFolderFileDownload({
          kijshopCd,
          orderId,
          path: `${cfFile.pathThumb}/${cfFile.orgFilename}`,
        }), {
          onSuccess: (res: Blob) => {
            const url = URL.createObjectURL(res);
            cache.current[cfFile.id] = url;
            setSrc(url);
          },
        }));
      });
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [cfFile.id]);

  return (
    <div
      ref={ref}
      className="folder_drop_zone_olc__list__thumb"
    >
      <div className="folder_drop_zone_olc__list__thumb__label" title={cfFile?.orgFilename ?? ''}>
        <span>{cfFile?.orgFilename || ''}</span>
      </div>
      <div className="folder_drop_zone_olc__list__thumb__image">
        {src ? (
          <ImageComponent
            src={src}
            alt=""
            {...imageProps}
          />
        ) : (
          <div className="folder_drop_zone_olc__list__thumb__image__loading">
            <div
              className="loading_popup__dots"
              style={{
                fontSize: '0.5rem',
                animationDuration: '1s',
                WebkitAnimationDuration: '1s',
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
});
